<template>
  <svg width="30px" height="30px"
       viewBox="0 0 30 30" version="1.1"
       xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>atoms/icons/30x30/file/black</title>
    <g id="atoms/icons/30x30/file/black" stroke="none"
       stroke-width="1"
       fill-rule="evenodd">
      <path d="M21.009747,4 C22.6666012,4 24.009747,5.34314575 24.009747,7 L24.009747,22.5957576 C24.009747,24.2526119 22.6666012,25.5957576 21.009747,25.5957576 L8,25.5957576 C6.34314575,25.5957576 5,24.2526119 5,22.5957576 L5,11.3424097 L10.9183962,4 L21.009747,4 Z M21.009747,6 L14.231,6 L14.2319891,12.3225244 C14.2319891,13.4270939 13.3365586,14.3225244 12.2319891,14.3225244 L7,14.322 L7,22.5957576 C7,23.1480424 7.44771525,23.5957576 8,23.5957576 L21.009747,23.5957576 C21.5620317,23.5957576 22.009747,23.1480424 22.009747,22.5957576 L22.009747,7 C22.009747,6.44771525 21.5620317,6 21.009747,6 Z M12.231,6 L11.874,6 L7,12.047 L7,12.322 L12.2319891,12.3225244 L12.231,6 Z" id="Combined-Shape"
            fill-rule="nonzero"></path>
    </g>
  </svg>
</template>
<script setup>
// dummy comment to surpress rollup build errors with dynamic imports
// if the file doesn't contain a script tag with content, the build fails.
</script>
